import Layout from 'antd/lib/layout'
import 'antd/lib/layout/style/index.less'

export default Layout
